import React, { FC } from 'react';
import { HighlightPair } from 'components/highlightPair/HighlightPair';
import { home } from 'texts/texts';
import './Highlights.css';

export const Highlights: FC = () => {
  return (
    <div className="highlights-section">
      <div className="home-content-container"
        style={{ background: 'linear-gradient(to bottom, var(--primary100) 20%, #fff7ee 80%)' }}
      >
        <div className='highlights-container'>
          {home.highlights.map((highlight, index) => (
            <HighlightPair
              key={index}
              title={highlight.title}
              description={highlight.description}
              imgSrc={`${process.env.PUBLIC_URL}/assets/highlightsSection/highlightImg${index + 1}.png`}
              imgAlt={`Highlight image ${index + 1}`}
              reverse={index % 2 !== 0}
            />
          ))}
        </div>
      </div>
    </div>
  )
};
